import { Helmet } from "react-helmet";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import "../../../../styles/Pages/Financial/CashInFlow/Dashboard/Dashboard.style.css";
import LineGraphChart from "../../../../components/PagesComponents/Financial/CashInFlow/Dashboard/LineGraphChart.component";
import BarGraphChart from "../../../../components/PagesComponents/Financial/CashInFlow/Dashboard/BarGraphChart.component";
import OthersList from "../../../../components/PagesComponents/Financial/CashInFlow/Dashboard/OthersList.component";
import CashInFlowPieChart from "../../../../components/PagesComponents/Financial/CashInFlow/Dashboard/CashInFlowPieChart.component";
import SheetLinks from "../../../../components/PagesComponents/Financial/CashInFlow/Dashboard/SheetLinks.component";

const Body = ({ lineChartData, donutChartData, grants, othersList }) => {
  return (
    <section className="cashInFlowDashboard">
      <Helmet>
        <title>Dashboard</title>
        <meta
          name="description"
          content="Monitor and analyze cash inflow trends and contributions."
        />
        <meta
          name="keywords"
          content="cash inflow, financial dashboard, cash flow analysis, business finance"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <PageHeader title={"Dashboard"} />
      <div className="Sheets">
        <SheetLinks />
      </div>
      <div className="cashInFlowMainContainer">
        <div className="cashInFlowGraphContainer">
          <div className="lineGraphChart">
            <LineGraphChart graphData={lineChartData} />
          </div>
          <div className="barGraphChart">
            <BarGraphChart graphData={grants} />
          </div>
        </div>
        <div className="cashInFlowPieChartContainer">
          <div className="pieChart">
            <CashInFlowPieChart donutChartData={donutChartData} />
          </div>
          <div className="othersList">
            <OthersList listData={othersList} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Body;
